import API from "./api";
import getFile from "./xml";
const config = getFile("/config.json");

const api = new API();

export { api, config };
export { default as sentry } from "./sentry";
